document.addEventListener("DOMContentLoaded", async function () {

    if (!window.location.pathname.includes("/products/gummies")) {
  return; // ❌ Exit for all other product pages
}


/* ============ MEDIA SWITCH (BACKEND IMAGES) ============ */

    /* ============ LOAD PRODUCTS ============ */

const PRODUCTS = {
  gummies: null,
  pulp: null
};

async function loadProduct(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    return await res.json();
  } catch (e) {
    console.error(`❌ Failed loading ${handle}`, e);
    return null;
  }
}

PRODUCTS.gummies = await loadProduct("gummies");
PRODUCTS.pulp = await loadProduct("sea-buckthorn-juice-pulp-300ml");



function populatePrices(type) {
  const productData = PRODUCTS[type];
  if (!productData) return;

  productData.variants.forEach(v => {
    const card = document.querySelector(
      `#variants-${type} .sb-plan-card[data-variant-id="${v.id}"]`
    );
    if (!card) return;

    const priceEl   = card.querySelector(".sb-plan-price");
    const compareEl = card.querySelector(".sb-plan-old-price");
    const saveEl    = card.querySelector(".sb-plan-save");

    const price   = v.price / 100;
    const compare = v.compare_at_price ? v.compare_at_price / 100 : null;

    /* Selling Price */
    if (priceEl) {
      priceEl.textContent = `₹ ${price.toLocaleString("en-IN")}`;
    }

    /* MRP */
    if (compareEl && compare && compare > price) {
      compareEl.textContent = `₹ ${compare.toLocaleString("en-IN")}`;
      compareEl.style.display = "block";
    } else if (compareEl) {
      compareEl.style.display = "none";
    }

    /* 🔥 SAVE AMOUNT (DYNAMIC) */
    if (saveEl && compare && compare > price) {
      const save = compare - price;
      saveEl.textContent = `Save ₹ ${save.toLocaleString("en-IN")}`;
      saveEl.style.display = "block";
    } else if (saveEl) {
      saveEl.style.display = "none";
    }
  });
}





function populateStickyPrices(type) {
  const productData = PRODUCTS[type];
  if (!productData) return;

  productData.variants.forEach(v => {
    const card = document.querySelector(
      `.msv-${type} .msv-card[data-variant-id="${v.id}"]`
    );
    if (!card) return;

    const priceEl = card.querySelector(".msv-price");
    const saveEl  = card.querySelector(".msv-save");

    const price   = v.price / 100;
    const compare = v.compare_at_price ? v.compare_at_price / 100 : null;

    if (priceEl) {
  priceEl.textContent = `₹${price.toLocaleString("en-IN")}`;
}

const mrpEl = card.querySelector(".msv-mrp");
if (mrpEl && compare && compare > price) {
  mrpEl.textContent = `₹${compare.toLocaleString("en-IN")}`;
  mrpEl.style.display = "block";
} else if (mrpEl) {
  mrpEl.style.display = "none";
}


    if (saveEl && compare && compare > price) {
      saveEl.textContent = `Save ₹${(compare - price).toLocaleString("en-IN")}`;
      saveEl.style.display = "block";
    }
  });
}





function switchGalleryByType(type) {

  /* ================= MAIN SLIDER ================= */
  const mainSlider = document.querySelector(".pf-media-slider");
  if (!mainSlider) return;

  const mainSlides = mainSlider.querySelectorAll(".pf-slide-main-media");
  let firstMain = null;

  mainSlides.forEach(slide => {
    const img = slide.querySelector("img");
    const alt = img?.alt?.toLowerCase() || "";

    if (alt.includes(type)) {
      slide.style.display = "";
      slide.setAttribute("aria-hidden", "false");
      if (!firstMain) firstMain = slide;
    } else {
      slide.style.display = "none";
      slide.setAttribute("aria-hidden", "true");
    }
  });

  mainSlides.forEach(s => s.classList.remove("is-current", "is-visible"));
  if (firstMain) {
    firstMain.classList.add("is-current", "is-visible");
    mainSlider.scrollLeft = firstMain.offsetLeft;
  }

  /* ================= THUMB / LIST SLIDER ================= */
  const listWrapper = document.querySelector(".pf-slide-list-media")?.parentElement;
  if (!listWrapper) return;

  const listSlides = listWrapper.querySelectorAll(".pf-slide-list-media");
  let firstThumb = null;

  listSlides.forEach(slide => {
    const img = slide.querySelector("img");
    const alt = img?.alt?.toLowerCase() || "";

    if (alt.includes(type)) {
      slide.style.display = "";
      if (!firstThumb) firstThumb = slide;
    } else {
      slide.style.display = "none";
    }
  });

  /* 🔥 Force PageFly to recalc layout */
  listWrapper.style.display = "none";
  listWrapper.offsetHeight;
  listWrapper.style.display = "";
}



/* ============ TITLE + REVIEW DATA ============ */
const VIEW_META = {
  gummies: {
    title: "Sea Buckthorn Gummies",
    rating: "4.5",
    units: "41K units sold",
    reviews: "785 Reviews"
  },
  pulp: {
    title: "Sea Buckthorn Juice",
    rating: "4.3",
    units: "1L units sold",
    reviews: "4620 Reviews"
  }
};




/* ===== PageFly-safe meta updater (Desktop + Mobile) ===== */
function updateVisibleMeta(type) {
  const meta = VIEW_META[type];
  if (!meta) return;

  document.querySelectorAll(".mm-rating-box").forEach(box => {
    if (box.offsetWidth === 0 || box.offsetHeight === 0) return;

    const rating  = box.querySelector("#mm-rating");
    const units   = box.querySelector("#mm-units");
    const reviews = box.querySelector("#mm-reviews");

    if (rating)  rating.textContent  = meta.rating;
    if (units)   units.textContent   = meta.units;
    if (reviews) reviews.textContent = meta.reviews;
  });

  const title = document.getElementById("product-title");
  if (title) title.textContent = meta.title;
}







//   document.addEventListener("click", function (e) {
//   const btn = e.target.closest(".sb-type-tab");
//   if (!btn) return;

//   const type = btn.dataset.target;

//   // Toggle tab UI
//   document.querySelectorAll(".sb-type-tab")
//     .forEach(b => b.classList.remove("active"));
//   btn.classList.add("active");

//   // Toggle variant groups
//   document.querySelectorAll(".sb-variants-group")
//     .forEach(g => g.classList.remove("active"));
//   document.querySelector(`#variants-${type}`)?.classList.add("active");

//   // Core actions
//   switchGalleryByType(type);
//   populatePrices(type);
//   populateStickyPrices(type);
//   autoSelectMiddle(type);
//   syncStickyWithMain(type);
//   updateVisibleMeta(type);

//    // ✅ DESCRIPTION SWITCH (THIS IS THE RIGHT PLACE)
//   document.querySelectorAll(".pf-desc").forEach(desc => {
//     desc.classList.toggle("active", desc.dataset.desc === type);
//   });


// });



  /* Prevent PageFly default add to cart */
  document.querySelectorAll("form[action='/cart/add']").forEach(f => {
    f.addEventListener("submit", e => {
      e.preventDefault();
      e.stopImmediatePropagation();
    });
  });


  function autoSelectMiddle(type) {
  const cards = document.querySelectorAll(`#variants-${type} .sb-plan-card`);
  if (!cards.length) return;

  cards.forEach(c => c.classList.remove("selected"));
  cards[Math.floor(cards.length / 2)].classList.add("selected");
}


function syncStickyWithMain(type) {
  const selected = document.querySelector(
    `#variants-${type} .sb-plan-card.selected`
  );
  if (!selected) return;

  const id = selected.dataset.variantId;

  document
    .querySelectorAll(`.msv-${type} .msv-card`)
    .forEach(card =>
      card.classList.toggle("active", card.dataset.variantId === id)
    );
}



/* =========================================
   TAB SWITCH – DESKTOP + STICKY (SYNCED)
========================================= */
function switchType(type) {

  // Tabs UI (desktop + sticky)
  document.querySelectorAll(".sb-type-tab, .msv-tab").forEach(tab => {
    tab.classList.toggle(
      "active",
      tab.dataset.target === type || tab.dataset.tab === type
    );
  });

  // Main variants
  document.querySelectorAll(".sb-variants-group")
    .forEach(g => g.classList.remove("active"));
  document.querySelector(`#variants-${type}`)?.classList.add("active");

  // Sticky variants
  document.querySelectorAll(".msv-variants")
    .forEach(v => v.classList.remove("active"));
  document.querySelector(`.msv-${type}`)?.classList.add("active");

  // Core updates
  switchGalleryByType(type);
  populatePrices(type);
  populateStickyPrices(type);
  autoSelectMiddle(type);
  syncStickyWithMain(type);
  updateVisibleMeta(type);

  // Description
  document.querySelectorAll(".pf-desc").forEach(desc =>
    desc.classList.toggle("active", desc.dataset.desc === type)
  );
}

/* Desktop tabs */
document.querySelectorAll(".sb-type-tab").forEach(tab => {
  tab.addEventListener("click", () => {
    switchType(tab.dataset.target);
  });
});

/* Sticky tabs */
document.querySelectorAll(".msv-tab").forEach(tab => {
  tab.addEventListener("click", () => {
    switchType(tab.dataset.tab);
  });
});



  
// ✅ DEFAULT LOAD (ONLY ONCE)
switchType("gummies");
  


  /* Card selector */
  document.querySelectorAll(".sb-plan-card").forEach(card => {
    card.addEventListener("click", () => {
      const parent = card.closest(".sb-variants-group");
      parent.querySelectorAll(".sb-plan-card").forEach(c => c.classList.remove("selected"));
      card.classList.add("selected");
    });
  });


/* ============================================================
   STICKY VARIANT → MAIN VARIANT SYNC
============================================================ */
document.querySelectorAll(".msv-card").forEach(stickyCard => {
  stickyCard.addEventListener("click", () => {

    const variantId = stickyCard.dataset.variantId;
    if (!variantId) return;

    // Sticky active state
    stickyCard
      .closest(".msv-variants")
      .querySelectorAll(".msv-card")
      .forEach(c => c.classList.remove("active"));

    stickyCard.classList.add("active");

    // 🔥 FORCE correct main group
    const activeTab =
      document.querySelector(".msv-tab.active")?.dataset.tab || "gummies";

    // Activate correct variant group
    document.querySelectorAll(".sb-variants-group")
      .forEach(g => g.classList.remove("active"));
    document.querySelector(`#variants-${activeTab}`)?.classList.add("active");

    // 🔥 FORCE select correct main variant
    document
      .querySelectorAll(`#variants-${activeTab} .sb-plan-card`)
      .forEach(card => {
        card.classList.toggle(
          "selected",
          card.dataset.variantId === variantId
        );
      });

  });
});














  /* Get selected variant */
  function getSelectedVariant(type) {

  // 1️⃣ Try main selected card
  const selected = document.querySelector(
    `#variants-${type} .sb-plan-card.selected`
  );
  if (selected) return selected.dataset.variantId;

  // 2️⃣ Fallback to sticky active card
  const stickySelected = document.querySelector(
    `.msv-${type} .msv-card.active`
  );
  return stickySelected ? stickySelected.dataset.variantId : null;
}


async function addToCart(variantId) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  });
}









document.querySelector(".msv-cta")?.addEventListener("click", async () => {

  const activeTab =
    document.querySelector(".msv-tab.active")?.dataset.tab || "gummies";

  const variantId = getSelectedVariant(activeTab);
  if (!variantId) {
    alert(`Please select a ${activeTab} pack`);
    return;
  }

  await addToCart(variantId);
  window.location.href = "/cart";
});







  document.querySelector(".sb-add-cart-btn-gummies")?.addEventListener("click", async () => {
    const id = getSelectedVariant("gummies");
    if (!id) return alert("Select a gummies pack");
    await addToCart(id);
    window.location.href = "/cart";
  });

  document.querySelector(".sb-add-cart-btn-pulp")?.addEventListener("click", async () => {
    const id = getSelectedVariant("pulp");
    if (!id) return alert("Select a pulp pack");
    await addToCart(id);
    window.location.href = "/cart";
  });


  /* ============================================================
     12. BUY NOW → CHECKOUT (GUMMIES)
  ============================================================ */
  const gummiesCheckout = document.querySelector(".sb-buy-now-btn-gummies");
if (gummiesCheckout) {
  gummiesCheckout.addEventListener("click", async () => {
    const id = getSelectedVariant("gummies");
    if (!id) return alert("Please select a gummies pack.");

    await addToCart(id);
    window.location.href = "/checkout";
  });
}

  

  /* ============================================================
     13. BUY NOW → CHECKOUT (PULP)
  ============================================================ */
  const pulpCheckout = document.querySelector(".sb-buy-now-btn-pulp");
  if (pulpCheckout) {
    pulpCheckout.addEventListener("click", async () => {
      const id = getSelectedVariant("pulp");
      if (!id) return alert("Please select a pulp pack.");

      await addToCart(id);
      window.location.href = "/checkout";
    });
}



// ===============================
// AUTOPLAY MUTED VIDEOS
// ===============================
document.querySelectorAll(".carousel-video").forEach(video => {
  video.play().catch(() => { });
});

// ===============================
// RIGHT ARROW SCROLL
// ===============================
const videoCarousel = document.getElementById("videoCarousel");
const rightArrow = document.getElementById("rightArrow");

rightArrow.addEventListener("click", () => {
  videoCarousel.scrollBy({
    left: 300,
    behavior: "smooth"
  });
});

// ===============================
// POPUP LOGIC (FIXED)
// ===============================
const popup = document.getElementById("videoPopup");
const closePopup = document.getElementById("closePopup");

// Open popup on card click
document.querySelectorAll(".video-card").forEach(card => {
  card.addEventListener("click", function () {

    const originalVideo = this.querySelector("video");

    // Clone video (keeps buffer)
    let cloned = originalVideo.cloneNode(true);
    cloned.id = "popupVideo";
    cloned.muted = false;
    cloned.controls = true;

    // Replace popup video
    const oldPopupVideo = document.getElementById("popupVideo");
    oldPopupVideo.replaceWith(cloned);

    // Show popup (CSS based)
    popup.classList.add("active");

    // Play video smoothly
    setTimeout(() => {
      cloned.play().catch(() => { });
    }, 50);
  });
});

// Close popup
closePopup.addEventListener("click", () => {
  const vid = document.getElementById("popupVideo");
  vid.pause();
  popup.classList.remove("active");
});

// Close popup when clicking outside the video
popup.addEventListener("click", (e) => {
  if (e.target === popup) {
    const vid = document.getElementById("popupVideo");
    vid.pause();
    popup.classList.remove("active");
  }
});

// ===============================
// MOUSE DRAG SCROLL
// ===============================
let isDown = false;
let startX;
let scrollLeft;

videoCarousel.addEventListener("mousedown", (e) => {
  isDown = true;
  videoCarousel.classList.add("active");
  startX = e.pageX - videoCarousel.offsetLeft;
  scrollLeft = videoCarousel.scrollLeft;
});

videoCarousel.addEventListener("mouseleave", () => {
  isDown = false;
  videoCarousel.classList.remove("active");
});

videoCarousel.addEventListener("mouseup", () => {
  isDown = false;
  videoCarousel.classList.remove("active");
});

videoCarousel.addEventListener("mousemove", (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - videoCarousel.offsetLeft;
  const walk = (x - startX) * 2;
  videoCarousel.scrollLeft = scrollLeft - walk;
});





  // Frequently Bought Together

    // Select all FBT product boxes
    const fbtBoxes = document.querySelectorAll(".fbt-box");

    fbtBoxes.forEach(box => {
      const priceElem = box.querySelector(".fbt-price");
      const compareElem = box.querySelector(".fbt-compare");
      const offElem = box.querySelector(".fbt-off");
      const addBtn = box.querySelector(".fbt-add-btn");

      const variantId = priceElem.dataset.variant;

      /* --------------------------
         FETCH LIVE PRICE
      --------------------------- */
      fetch(`/variants/${variantId}.js`)
        .then(res => res.json())
        .then(variant => {
          const price = variant.price / 100;
          const compare = variant.compare_at_price ? variant.compare_at_price / 100 : null;
          const discountPercent = compare ? Math.round(((compare - price) / compare) * 100) : 0;

          priceElem.textContent = `₹${price.toLocaleString("en-IN")}`;

          if (compareElem && compare) {
            compareElem.textContent = `₹${compare.toLocaleString("en-IN")}`;
          }

          if (offElem && compare) {
            offElem.textContent = `${discountPercent}% OFF`;
          }
        })
        .catch(err => console.error("Price fetch error:", err));


      /* --------------------------
         AJAX ADD TO CART
      --------------------------- */
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // If already added → redirect to cart
        if (addBtn.dataset.state === "added") {
          window.location.href = "/cart";
          return;
        }

        addBtn.disabled = true;
        addBtn.innerText = "Adding...";

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
          .then(res => res.json())
          .then(() => {
            addBtn.dataset.state = "added";
            addBtn.innerText = "VIEW CART";
            addBtn.disabled = false;
            addBtn.classList.add("added-to-cart");

            // ⭐ Show "Added to cart" message
            const statusMsg = box.querySelector(".fbt-status-msg");
            if (statusMsg) {
              statusMsg.style.display = "block";
              statusMsg.innerText = "Added to cart!";

              setTimeout(() => {
                statusMsg.style.display = "none";
              }, 3000);

            }
          })
          .catch(err => { console.error("Cart error:", err); addBtn.innerText = "ADD TO CART"; addBtn.disabled = false; });
      });
    });
  });


// Frequently Bought Together
